package com.essntl.features.dashboard.ui.components.taskcard

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import core.dateformat.utils.isDateOverDue
import com.essntl.features.dashboard.ui.DashboardState
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberEquals
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import core.dateformat.ui.formatDateToPrettyString

@Composable
fun TaskCard(
    state: DashboardState,
    task: TaskModel,
    selectedId: String?,
    onClick: () -> Unit,
) {
    val isSelected = rememberEquals(task.id, setOf(selectedId)) { it }

    Box(
        modifier = Modifier
            .clip(RoundedCornerShape(16.dp))
            .background(
                color = when {
                    isSelected ->
                        MaterialTheme.esColorScheme.tintedPressed

                    else -> MaterialTheme.esColorScheme.bgSecondary
                },
            )
            .clickable {
                onClick()
            }
            .padding(1.spacing),
    ) {
        Row(
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier = Modifier.fillMaxWidth(),
        ) {
            Column(
                verticalArrangement = Arrangement.spacedBy(0.spacing),
                modifier = Modifier.weight(9F),
            ) {
                Text(
                    text = task.title ?: "no title!",
                    style = MaterialTheme.esTypography.p1Medium16,
                    overflow = TextOverflow.Ellipsis,
                )

                when {
                    task.itinerary != null -> ItineraryTask(task = task)

                    task.itineraryService != null ->
                        ServiceTask(
                            task = task,
                            state = state,
                        )

                    else -> OwnerTask(task = task)
                }
            }

            Column(
                verticalArrangement = Arrangement.spacedBy(0.spacing),
                horizontalAlignment = Alignment.End,
                modifier = Modifier.weight(1F),
            ) {
                Text(
                    text = "Due",
                    style = MaterialTheme.esTypography.p2Medium14.copy(
                        color = MaterialTheme.esColorScheme.textSecondary,
                    ),
                )

                Text(
                    text = task.dueDate?.formatDateToPrettyString() ?: "_",
                    style = MaterialTheme.esTypography.p2Medium14.copy(
                        color = if (isDateOverDue(task.dueDate))
                            MaterialTheme.esColorScheme.textError
                        else
                            MaterialTheme.esColorScheme.textSecondary,
                    ),
                )
            }
        }
    }
}